(function () {
    'use strict';

    angular.module('app').controller('CorporateUsersController', CorporateUsersController);

    CorporateUsersController.$inject = [
        '$scope', '$rootScope', '$routeParams', '$location', 'LANGS', '$filter', '$timeout',
        '$q', '$uibModal', 'blockUI',
        'ExportService',
        'SelectService',
        'NotifyService',
        'MessageService',
        'TransactionService',
        'CouponsService',
        'CustomPreferencesService',
        'SettingsService',
        'BusinessService',
        'CorporateCustomerService',
        'GoodsService',
        'POSService',
        '$sce',
        'TaxesExemptInCorporateService'
    ];

    function CorporateUsersController($scope, $rootScope, $routeParams, $location, LANGS, $filter, $timeout,
                                      $q, $uibModal, blockUI,
                                      ExportService,
                                      SelectService,
                                      NotifyService,
                                      MessageService,
                                      TransactionService,
                                      CouponsService,
                                      CustomPreferencesService,
                                      SettingsService,
                                      BusinessService,
                                      CorporateCustomerService,
                                      GoodsService,
                                      POSService,
                                      $sce,
                                      TaxesExemptInCorporateService
    ) {

        var storage_customers_filters_set = 'cfs_corporate' + $rootScope.ENV.tools.storage_suffix;
        var customPreferencesKey = 'CORPORATE_USERS_TABLE_COLS';
        $scope.modal = {};
        $scope.selectedUsers = {};
        $scope.selectedUsersCount = selectedUsersCount;

        $scope.isPhoneValid = isPhoneValid;
        $scope.isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';

        $scope.model = {
            corporate_customer: {}, // текущий корпаративный клиент
            corporate_special_accounts: {}, // Все корпоративные счета
            corporate_customer_special_accounts: {} // Все корпоративные счета для данного корпоротивного клиента
        };
        $scope.state = {
            selectedAll: false
        };

        $scope.multilang = MultilanguageHelper();

        $scope.params = {
            page: 1,
            count: 10,
            suspended: 'all',
            category_id: null
        };

        $scope.data = {
            suspendedTypes: [
                {id: 'all', title: 'All'},
                {id: 'yes', title: 'Yes'},
                {id: 'no', title: 'No'}
            ],
            categoriesType: [
                {id: 'none', title: 'Uncategorized'}
            ],
            categoriesTypeActive: [
                {id: 'none', title: 'Uncategorized'}
            ],
            // showAdvancedFilters: false,
            isFilePreparing: false
        };

        $scope.state = {
            showLimited: false,
            goodsList: [],
            posList: []
        };

        $scope.pager_count = [10, 20, 50, 100, 200];

        $scope.fieldsTypes = [
            {value: 'string', text: 'String'},
            {value: 'date', text: 'Date'},
            {value: 'integer', text: 'Number'},
            {value: 'money', text: 'Money'},
            {value: 'dictionary', text: 'Dictionary'}
        ];

        $scope.table_cols_preset = [
            {
                visible: true,
                data: [
                    {
                        value: 'corporate_name',
                        text: 'Corporate user name',
                        visible: true,
                        sorting: 'name'
                    },
                    {
                        value: 'corporate_login',
                        text: 'Corporate user login',
                        visible: true,
                        sorting: 'email'
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'corporate_contact_person',
                        text: 'Corporate contact person',
                        visible: true
                    },
                    {
                        value: 'corporate_category',
                        text: 'Card category type',
                        visible: true

                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'corporate_contact_phones',
                        text: 'Corporate phones',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'corporate_contact_mobile',
                        text: 'Corporate mobile',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'corporate_contact_email',
                        text: 'Corporate email address',
                        visible: true
                    }
                ]
            },
            {
                visible: false,
                data: [
                    {
                        value: 'corporate_contact_address',
                        text: 'Corporate address',
                        visible: false
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'corporate_suspended',
                        text: 'Suspended',
                        visible: true
                    }
                ]
            }
        ];
        // Добавляем возможность отобразить пустую колонку в экспортируемом документе
        $scope.table_cols_preset = CustomPreferencesService.addBlankColumns($scope.table_cols_preset);

        $scope.getCountriesList = SelectService.getCountriesList;

        $scope.currentTab = 'corporate_main_settings';
        $scope.LANGS = LANGS;
        $scope.summary = {};
        $scope.CORPORATE_CUSTOMER_FIELDS = {};
        $scope.getFiltersList = SelectService.getLPRList;

        $scope.getCustomers = getCustomers;
        $scope.filterHelper = {};

        $scope.getPages = getTotalPaginatedPages;

        $scope.isPageMode = isPageMode;
        $scope.isModifyDenied = isModifyDenied;

        $scope.popupChengeCategory = popupChengeCategory;
        // $scope.isConsentExist = isConsentExist;

        // $scope.date_picker = {
        //     opened: false
        // };

        // $scope.model.inlineMessage = '';

        var block_clients_list = blockUI.instances.get('clients_list'),
            block_fields_list = blockUI.instances.get('fields_list'),
            block_edit_corporate_user = blockUI.instances.get('edit_corporate_user');

        var getCustomersInProcessFrom = null;

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        initController();
        var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            $scope.getCountriesList();
        });
        $scope.$on('$destroy', unbindTranslateChangeSuccess);
        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display differed parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../pos/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('customer_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';

            if (isRouteMode('fields')) $scope._pageMode = 'fields';
        }

        function initController() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);

            initPageMode();

            initTableColumns();
            getCorporateCategories();
            block_fields_list.start();
            CorporateCustomerService.CorporateFields(function (success, data) {
                if (success) {
                    $scope.CORPORATE_CUSTOMER_FIELDS = data;

                    $scope.customerFields = $scope.CORPORATE_CUSTOMER_FIELDS;

                    switch ($scope._pageMode) {
                        case 'create':
                            doCreate();
                            break;

                        case 'show':
                            doShow();
                            break;

                        case 'fields':
                            doEditFields();
                            break;

                        case 'edit':
                            doEdit();
                            break;
                    }
                }
                block_fields_list.stop();
            });

        }

        /**
         * Return custom field name for SQL query
         * @param name
         */
        function customFieldSQLName(name) {
            if ((name.indexOf('-') > 0 || $scope.customersFilters.staticFieldsIds.indexOf(name) === -1) &&
                name.indexOf('bcf_') === -1 &&
                name !== 'card_category_title')
                return 'bcf_{0}_value'.format(name.replace(/[-]*/g, ''));
            else
                return name;
        }

        /**
         * Return selected users count
         */
        function selectedUsersCount() {
            var result = 0;
            for (var i in $scope.selectedUsers) {
                if ($scope.selectedUsers[i])
                    result += 1;
            }
            return result;
        }

        /**
         * Return array with ID of only selected users
         */
        function selectedUsersToArray() {
            var result = [];
            for (var i in $scope.selectedUsers) {
                if ($scope.selectedUsers[i]) result.push(i);
            }
            return result;
        }

        /**
         * Return TRUE if any user selected
         * @returns {boolean}
         */
        function existSelectedUsers() {
            for (var i in $scope.selectedUsers) {
                if ($scope.selectedUsers[i]) return true;
            }
            return false;
        }

        $scope.popupRefillSpecialAccount = function popupRefillSpecialAccount(corporate_customer, options) {
            console.info('popupRefillSpecialAccount', corporate_customer);

            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/pages/corporates/corporate-users/modal/corporate-user.refillspecialaccount.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.corporate_customer = corporate_customer;
                    popup.model = {};
                    popup.data = {};

                    CorporateCustomerService.GetCorporateCustomerSpecialAccounts(popup.corporate_customer.id, function (success, data) {
                        popup.data.corporate_special_accounts = [];
                        if (success) {
                            popup.data.corporate_special_accounts = data;
                            if (options && options.special_account_id) {
                                popup.model.special_account_id = options.special_account_id;
                            }
                        }
                    });

                    popup.onOk = function () {
                        CorporateCustomerService.RefillCorporateCustomerSpecialAccount(
                            popup.corporate_customer.id,
                            popup.model.special_account_id,
                            {
                                amount: popup.model.charge_amount,
                                comment: popup.model.comment
                            },
                            function (success, data) {
                                if (success) {
                                    getCustomers();
                                    $uibModalInstance.close();
                                }
                            });
                    };

                    popup.addAccess = function () {
                        $uibModalInstance.close();
                        $location.path('/corporate-users/edit/' + popup.corporate_customer.id).search({tab: 'special-accounts'});
                        // $location.path('/corporate-users/edit/{0}?tab=special-accounts'.format(popup.corporate_customer.id));
                        // $location.path('/corporate-users/edit/'+ popup.corporate_customer.id+'?tab=special-accounts');
                    };

                    popup.onCancel = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        function getCorporateCategories() {
            CorporateCustomerService.GetCorporateCustomersCategories(function (success, data) {
                if (success) {
                    $scope.data.categoriesType = $scope.data.categoriesType.concat(...data);
                    var categories = data.filter(function (category) {
                        return !!category.active;
                    });
                    $scope.data.categoriesTypeActive = $scope.data.categoriesTypeActive.concat(...categories);
                    console.log('$scope.data.categoriesType', $scope.data.categoriesType);
                    $scope.model.category = $scope.data.categoriesType[0];
                }
            });

        }

        /**
         * Show popup for change   category
         */
        function popupChengeCategory() {
            $scope.modalCardCategory = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.cardcategory.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.isCorp = false;
                    popup.model = {};

                    popup.data = {};

                    popup.step = 0;
                    $rootScope.REQUEST_ABORT_PENDING = false;

                    popup.usersCount = $scope.summary.total_rows_count;
                    popup.selectedCount = $scope.selectedUsersCount();
                    popup.sendTo = popup.selectedCount == 0 ? 'all' : 'selected';

                    popup.params = {
                        category_id: 'none'
                    };
                    CorporateCustomerService.AllIds(popup.params, function (success, response) {
                        popup.usersCountNoCategory = response.length;

                    });
                    CorporateCustomerService.GetCorporateCustomersCategories(function (success, response) {
                        if (success) {
                            popup.data.cardCategories = response;

                            if (popup.data.cardCategories.length > 0) {
                                popup.model.card_category_id = popup.data.cardCategories[0].id;
                                popup.data.cardCategories = popup.data.cardCategories.filter(function (category) {
                                    return !!category.active;
                                });
                            }

                        }
                    });

                    popup.getCategoryTitle = function (category_id) {
                        if (popup.data.cardCategories)
                            return itemByIndex(popup.data.cardCategories, category_id).title;
                    };

                    popup.onOk = function () {
                        if (popup.step == 1) {
                            var post_data = {
                                category_id: popup.model.card_category_id
                            };

                            popup.model.chunk_size = 50;

                            popup.model.users = selectedUsersToArray();
                            popup.model.total_elements = popup.model.users.length;

                            popup.model.request_progress = 0.1;

                            if (popup.sendTo == 'all') {
                                popup.params = {};
                                CorporateCustomerService.AllIds(popup.params, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, CorporateCustomerService.CardCategoryAssignToUser, $uibModalInstance,
                                        {update_user_list: true});
                                });
                            } else if (popup.sendTo == 'selected') {
                                processRequest(popup, post_data, CorporateCustomerService.CardCategoryAssignToUser, $uibModalInstance,
                                    {update_user_list: true});
                            } else if (popup.sendTo == 'no-category') {
                                popup.params = {
                                    category_id: 'none'
                                };
                                CorporateCustomerService.AllIds(popup.params, function (success, response) {
                                    popup.model.users = response;
                                    popup.model.total_elements = popup.model.users.length;
                                    processRequest(popup, post_data, CorporateCustomerService.CardCategoryAssignToUser, $uibModalInstance,
                                        {update_user_list: true});
                                });
                            }

                        } else popup.step += 1;
                    };

                    popup.onRequestAbort = function () {
                        $rootScope.REQUEST_ABORT_PENDING = true;
                        popup.model.request_progress = 0;
                    };

                    popup.onCancel = function (exit) {
                        if (!exit) popup.step -= 1;
                        if (exit || popup.step < 0) $uibModalInstance.close();
                    };
                }
            });
        }

        function processRequest(popup, post_data, request, modal, options) {
            $scope.model.inlineMessage = '';

            popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
            post_data.users = popup.model.chunk;

            if (!post_data.type) {
                post_data.type = popup.model.delivery_method;
            }

            function handleResult(success, data) {
                if (!$rootScope.REQUEST_ABORT_PENDING) {
                    if (success) {
                        popup.model.request_progress += popup.model.chunk.length / popup.model.total_elements * 100;
                        if (options && options.error_report) {
                            $scope.sendingResult.success += data.success;
                            $scope.sendingResult.error += data.error;
                            $scope.sendingResult.no_processed += data.no_processed;
                        }

                        if (options && options.price_calc) {
                            $scope.sendingResult.cost += data.cost;
                            $scope.sendingResult.error += data.error;
                            $scope.sendingResult.no_processed += data.no_processed;
                        }

                        if (options && options.error_log && data.error.length > 0) {
                            $scope.sendingResult.error_log = $scope.sendingResult.error_log.concat(data.error);
                        }

                        if (popup.model.users.length > 0) {
                            popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
                            post_data.users = popup.model.chunk;

                            request(post_data, handleResult);
                        } else {
                            if (!options || (options && !options.price_calc)) {
                                modal.close();
                            }

                            if (options && options.price_calc) {
                                $scope.sendingResult.priceCalculated = true;
                            }

                            if (options && options.update_user_list) {
                                getCustomers();
                            }

                            if (options && ($scope.sendingResult && $scope.sendingResult.error_log && $scope.sendingResult.error_log.length > 0 ||
                                options.error_report && !options.price_calc)
                            ) {
                                modal.close();
                                popupOperationResult($scope.sendingResult, options);
                            } else {
                                if (options.callbackOnSuccess) {
                                    options.callbackOnSuccess();
                                }
                            }

                        }
                    }
                } else {
                    $rootScope.REQUEST_ABORT_PENDING = false;
                }
            }

            request(post_data, handleResult);
        }

        function popupOperationResult(r, o) {
            $scope.modalOperationResult = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.customer.operation_result.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.result = r;
                    popup.options = o;

                    popup.onErrosLogExport = function (format) {
                        var file_name = $rootScope.ENV.business.code + '_errors_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                        switch (format) {
                            case 'XLSX':
                                alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [popup.result.error_log]);
                                break;
                            case 'XLS':
                                alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [popup.result.error_log]);
                                break;
                            case 'CSV':
                                alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [popup.result.error_log]);
                                break;
                        }
                    };

                    popup.onOk = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.popupWriteOffSpecialAccount = function popupWriteOffSpecialAccount(corporate_customer, options) {
            console.info('popupWriteOffSpecialAccount', corporate_customer, options);
            confirmationPopup('WriteOffCorporateSpecialAccount', function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/pages/corporates/corporate-users/modal/corporate-user.write-off-special-account.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.corporate_customer = corporate_customer;
                        popup.model = {};
                        popup.data = {};

                        CorporateCustomerService.GetCorporateCustomerSpecialAccounts(popup.corporate_customer.id, function (success, data) {
                            popup.data.corporate_special_accounts = [];
                            if (success) {
                                popup.data.corporate_special_accounts = data;
                                if (options && options.special_account_id) {
                                    popup.model.special_account_id = options.special_account_id;
                                }
                            }
                        });

                        popup.onOk = function () {
                            CorporateCustomerService.WriteOffsCorporateCustomerSpecialAccount(
                                popup.corporate_customer.id,
                                popup.model.special_account_id,
                                {
                                    amount: popup.model.charge_amount,
                                    comment: popup.model.comment
                                },
                                function (success, data) {
                                    if (success) {
                                        getCustomers();
                                        $uibModalInstance.close();
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_WRITE_OFF_CORPORATE_SPECIAL_ACCOUNT'), false);
                                    }

                                });
                        };

                        popup.addAccess = function () {
                            $uibModalInstance.close();
                            $location.path('/corporate-users/edit/' + popup.corporate_customer.id).search({tab: 'special-accounts'});
                        };

                        popup.onCancel = function (exit) {
                            $uibModalInstance.close();
                        };
                    }
                });
            }, corporate_customer);

        };

        $scope.popupAdjustmentSpecialAccount = function popupAdjustmentSpecialAccount(corporate_customer, options) {
            console.info('popupAdjustmentSpecialAccount', corporate_customer);
            confirmationPopup('AdjustmentCorporateSpecialAccount', function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/pages/corporates/corporate-users/modal/corporate-user.adjustment-special-account.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.corporate_customer = corporate_customer;
                        popup.model = {};
                        popup.data = {};

                        CorporateCustomerService.GetCorporateCustomerSpecialAccounts(popup.corporate_customer.id, function (success, data) {
                            popup.data.corporate_special_accounts = [];
                            if (success) {
                                popup.data.corporate_special_accounts = data;
                                if (options && options.special_account_id) {
                                    popup.model.special_account_id = options.special_account_id;
                                }
                            }
                        });

                        popup.onOk = function () {
                            CorporateCustomerService.AdjustCorporateCustomerSpecialAccount(
                                popup.corporate_customer.id,
                                popup.model.special_account_id,
                                {
                                    amount: popup.model.charge_amount,
                                    comment: popup.model.comment
                                },
                                function (success, data) {
                                    if (success) {
                                        getCustomers();
                                        $uibModalInstance.close();
                                        NotifyService.Success($filter('translate')('NOTIFY_SUCCESS_ADJUST_CORPORATE_SPECIAL_ACCOUNT'), false);
                                    }

                                });
                        };

                        popup.addAccess = function () {
                            $uibModalInstance.close();
                            $location.path('/corporate-users/edit/' + popup.corporate_customer.id).search({tab: 'special-accounts'});
                            // $location.path('/corporate-users/edit/{0}?tab=special-accounts'.format(popup.corporate_customer.id));
                            // $location.path('/corporate-users/edit/'+ popup.corporate_customer.id+'?tab=special-accounts');
                        };

                        popup.onCancel = function (exit) {
                            $uibModalInstance.close();
                        };
                    }
                });
            }, corporate_customer);
        };

        function confirmationPopup(type_confirmation, callbackDone, corporate_customer) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/corporates/corporate-users/modal/confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type_confirmation = type_confirmation;

                    popup.onDoneClick = function () {
                        $uibModalInstance.close();
                        if (callbackDone) {
                            callbackDone();
                        }
                    };

                    popup.onAdjustmentSpecialAccount = function () {
                        $uibModalInstance.close();
                        $scope.popupAdjustmentSpecialAccount(corporate_customer);
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.goodsTagHandler = function (code) {
            console.log('goodsTagHandler', code);
            return {title: '', code: code};
        };

        $scope.pasteTagHandler = function (values) {
            var separators = [',', '\n'],
                separator,
                values_list;

            for (var i in separators)
                if (values && values.indexOf(separators[i]) > 0)
                    separator = separators[i];

            if (separator)
                values_list = values.replace(' ', '').split(separator);
            else
                values_list = values.split(' ');

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (!this.ngModel.$modelValue)
                        this.ngModel.$modelValue = [];
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push({title: '', code: values_list[i]});
                    }
                }
            }
        };

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Show customers
         */
        function doShow() {
            $scope.field_type_and = 'user_phone';
            $scope.field_type_or = 'user_phone';

            getCustomers();
        }

        function initTableColumns(isReset) {
            if (!isReset) {
                block_clients_list.start();
                CustomPreferencesService.initTableColumns(
                    customPreferencesKey,
                    $scope.table_cols_preset
                ).then(function (preferences) {
                    $scope.table_cols = preferences.tableColumns;
                    block_clients_list.stop();
                });
            } else {
                $scope.table_cols = angular.copy($scope.table_cols_preset);
            }
        }

        /**
         * Send to server query for get transactions
         */
        function getCustomers() {
            var CURR_TIME = new Date();
            if (getCustomersInProcessFrom && (CURR_TIME - getCustomersInProcessFrom) < 180) {
                console.warn('Previous getCustomers() in process. Skip.');
                return;
            } else {
                getCustomersInProcessFrom = CURR_TIME;
            }

            block_clients_list.start();

            function handleResults(success, data) {
                if (success) {

                    $scope.customers = angular.copy(data.data);

                    $scope.summary = data.summary;
                }

                block_clients_list.stop();
                getCustomersInProcessFrom = null;
            }

            // CustomerService.All(params, handleResults);
            CorporateCustomerService.All($scope.params, handleResults);
        }

        $scope.onColumnsReset = function () {
            initTableColumns(true);
        };

        $scope.onColumnAdd = function (first) {
            if (first)
                $scope.table_cols.unshift({visible: true, data: []});
            else
                $scope.table_cols.push({visible: true, data: []});
        };

        $scope.onColumnRemove = function (index) {
            $scope.table_cols.splice(index, 1);
        };

        $scope.onColumnDisplayChange = function (index) {
            for (var i in $scope.table_cols[index].data)
                $scope.table_cols[index].data[i].visible = $scope.table_cols[index].visible;

        };
        $scope.goTOCommercialPanel = function (user) {
            if (!user.access.granted) {
                return;

            }
            BusinessService.Get(function (success, data) {
                window.open(
                    'https://{0}/auth?login={1}&admin={2}&businessId={3}'.format(appConfig.platformParams.ca_site[$scope.LANG], user.email,
                        $rootScope.USER.login, data.id),
                    '_blank');
            });

        };
        $scope.onColumnDataDisplayChange = function (index) {
            $scope.table_cols.forEach(function (column) {
                column.visible = column.data.some(function (data) {
                    return data.visible;
                });
            });
        };

        /**
         * Show or hide block with filters
         * @param isShow
         */
        /**
         * Select all checkboxes
         */
        $scope.onSelectAllUsers = function () {

            for (var i in $scope.customers)
                $scope.selectedUsers[$scope.customers[i].id] = !$scope.state.selectedAll;
        };

        // *********************************************************************************************
        //  POPUP-s PART
        // *********************************************************************************************

        $scope.popupCustomerDetail = function (customer) {
            $scope.userDetailInstance = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'lg',
                templateUrl: 'app/pages/corporates/corporate-users/modal/corporate-user.detail.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.corporate_customer = customer;
                    popup.customerFields = $scope.CORPORATE_CUSTOMER_FIELDS;
                    popup.customer_corporate_special_accounts = [];
                    popup.corporate_special_accounts = [];
                    popup.isPrimeFuel = $scope.isPrimeFuel;
                    BusinessService.SpecialAccountsParams({scope: 'corporate'}, function (success, data) {
                        popup.corporate_special_accounts = data;
                    });

                    CorporateCustomerService.GetCorporateCustomer(customer.id, function (success, data) {
                        if (success) {
                            popup.corporate_customer = data;
                            CorporateCustomerService.GetCorporateCustomerSpecialAccounts(popup.corporate_customer.id, function (success, data) {
                                if (success) {
                                    popup.customer_corporate_special_accounts = data;
                                    // popup.corporate_special_accounts = data;
                                }
                            });
                        } else {
                            $uibModalInstance.close();
                        }
                    });

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };

                    popup.popupRefillSpecialAccount = function (corporate_customer, options) {
                        $uibModalInstance.close();
                        $scope.popupRefillSpecialAccount(corporate_customer, options);
                    };

                    popup.popupWriteOffSpecialAccount = function (corporate_customer, options) {
                        $uibModalInstance.close();
                        $scope.popupWriteOffSpecialAccount(corporate_customer, options);
                    };

                    popup.popupAdjustmentSpecialAccount = function (corporate_customer, options) {
                        $uibModalInstance.close();
                        $scope.popupAdjustmentSpecialAccount(corporate_customer, options);
                    };

                    popup.onCustomerEdit = function (id) {
                        $uibModalInstance.close();
                        $location.path('/corporate-users/edit/{0}'.format(id));
                    };

                    popup.onCustomerEditSpecialAccounts = function (id) {
                        $uibModalInstance.close();
                        $location.path('/corporate-users/edit/{0}'.format(id)).search({tab: 'special-accounts'});
                    };
                    // http://localhost:3000/corporate/transactions%3Fcorporate_customer_id=%7B0%7D?corporate_customer_id=c7e197cc-e5da-4541-9616-cb22f0e1e4e2&special_account_id=164d31dd-ef1d-48ac-9176-9b73eae83136
                    popup.toTransactions = function (corporate_customer_id, special_account_id) {
                        $uibModalInstance.close();
                        if (special_account_id) {
                            $location.path('/corporate/transactions').search({
                                corporate_customer_id: corporate_customer_id,
                                special_account_id: special_account_id
                            });
                        } else {
                            $location.path('/corporate/transactions').search({corporate_customer_id: corporate_customer_id});
                        }

                    };
                    popup.onEditCorporateSpecialAccounts = function () {
                        $uibModalInstance.close();
                        $location.path('/corporate-accounts');
                    };
                    popup.close = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.onChangeTab = function (tab) {

            var form = angular.element('#form_corporate_edit_user_main').scope().form_corporate_edit_user_main;

            if ($scope.currentTab == 'corporate_main_settings' && isPageMode('create')) {

                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'sm',

                    templateUrl: 'app/pages/corporates/corporate-users/modal/modal.confirmation.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this,
                            redirectToTab = tab;

                        popup.onSaveClick = function () {
                            console.log('popup.onSaveClick', redirectToTab, tab);
                            $scope.onSaveCorporateCustomer(form, redirectToTab, false);

                            $uibModalInstance.close();
                        };

                        popup.onCancelClick = function (exit) {
                            if (isPageMode('create'))
                                $scope.currentTab = 'corporate_main_settings';
                            else {
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                            }
                            $uibModalInstance.close();
                        };
                    }
                });
            } else {

                if (tab === 'special-accounts') {
                    block_edit_corporate_user.start();
                    refreshCorporateCustomerSpecialAccounts();
                }

                $scope.currentTab = tab;
                $location.url($location.$$path + '?tab=' + tab);
            }
        };

        // *********************************************************************************************
        //  CREATE & EDIT CUSTOMER PART
        // *********************************************************************************************

        /**
         * Prepare data for display page in mode 'create'
         */
        function doCreate() {
            if ($scope.currentTab === 'fields' && $scope.CORPORATE_CUSTOMER_FIELDS.length === 0) {
                $scope.onChangeTab('corporate_main_settings');
            }

            $scope.model.corporate_customer = {};

            $scope.customerFields = $scope.CORPORATE_CUSTOMER_FIELDS;

            for (var i in $scope.customerFields) {
                $scope.customerFields[i].value = null;
            }

        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function doEdit() {
            console.log('doEdit');
            block_edit_corporate_user.start();
            if ($routeParams['tab']) {
                $scope.onChangeTab($routeParams['tab']);
            }

            CorporateCustomerService.GetCorporateCustomer($routeParams.customer_id, function (success, response) {
                if (success) {
                    if (response.contacts.length === 0) {
                        response.contacts.push({});
                    }
                    $scope.customerFields = $scope.CORPORATE_CUSTOMER_FIELDS;
                    $scope.model.corporate_customer = angular.copy(response);
                    $scope.model.category = $scope.model.corporate_customer.category || {
                        id: 'none',
                        title: 'Uncategorized'
                    };
                } else {
                    $location.path('/corporate-users');
                }

                block_edit_corporate_user.stop();
            });
        }

        $scope.addContactBlock = function () {
            $scope.model.corporate_customer.contacts.push({});
        };
        $scope.removeContactBlock = function (index) {
            if ($scope.model.corporate_customer.contacts.length > 1) {
                $scope.model.corporate_customer.contacts.splice(index, 1);
            } else {
                $scope.model.corporate_customer.contacts[0] = {};
            }
        };

        $scope.onSaveCorporateCustomer = function (form, redirectToTab, close) {
            console.log('receiveResult::close', close, redirectToTab);
            if (form) {
                if (!form.$valid) {
                    if (!form.email.$valid) {
                        form.email.$dirty = true;
                    }
                    if (!form.name.$valid) {
                        form.name.$dirty = true;
                    }
                    return;
                }
                form.name.$dirty = form.email.$dirty = false;
            }

            function receiveResult(success, data) {
                if (success) {
                    console.log('receiveResult::close', close, redirectToTab);
                    if (redirectToTab) {
                        $scope.currentTab = redirectToTab;
                        $location.path('/corporate-users/edit/' + data.id).search({tab: redirectToTab});

                    } else if (!close) {
                        $location.path('/corporate-users');
                    }
                }
                block_edit_corporate_user.stop();
            }

            var post_data = angular.copy($scope.model.corporate_customer);
            post_data.category_id = $scope.model.category.id === 'none' ? null : $scope.model.category.id;
            post_data.category = null;

            // TODO valid

            block_edit_corporate_user.start();
            post_data = cleanRequestData(post_data);
            if ($scope.isPageMode('create')) {
                CorporateCustomerService.AddCorporateCustomer(post_data, receiveResult);
            } else {
                CorporateCustomerService.UpdateCorporateCustomers(post_data.id, post_data, receiveResult);
            }
        };

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            if ($routeParams['r']) {
                $location.path('/' + $routeParams['r']);
                $location.search('r', null);
            } else {
                $location.path('/corporate-users');
            }
        };

        $scope.onDisplaySettingsClick = function () {
            if ($scope.state.showTableDisplaySettings) {
                CustomPreferencesService.saveCustomPreference(
                    customPreferencesKey,
                    {tableColumns: $scope.table_cols}
                ).then(function () {
                    block_clients_list.stop();
                }, function () {
                    block_clients_list.stop();
                });
            }
            $scope.state.showTableDisplaySettings = !$scope.state.showTableDisplaySettings;
        };

        $scope.onDisplaySettingsSave = function () {
            $scope.onDisplaySettingsClick();
        };

        // *************************************************************************************************************
        //  EDIT FIELDS PART
        // *************************************************************************************************************

        function doEditFields() {
            $scope.newField = {
                type: 'string',
                dictionary: []
            };
        }

        function refreshFields(callback) {
            CorporateCustomerService.CorporateFields(function (success, data) {
                if (success) {
                    $scope.CORPORATE_CUSTOMER_FIELDS = data;
                    //$scope.customersFilters.addCustomerFields($scope.CORPORATE_CUSTOMER_FIELDS);
                    $scope.customerFields = $scope.CORPORATE_CUSTOMER_FIELDS;
                }
                if (callback) {
                    callback();
                }

                block_fields_list.stop();

            });
        }

        $scope.onAccountCorporateCustomerToggleClick = function (CorporateCustomerId, CorporateCustomerSpecialAccount) {
            block_edit_corporate_user.start();
            CorporateCustomerService.UpdateCorporateCustomerSpecialAccount(
                CorporateCustomerId,
                CorporateCustomerSpecialAccount.id,
                {
                    active: CorporateCustomerSpecialAccount.active === 1 ? 0 : 1
                },
                function (success, data) {
                    if (success) {
                        refreshCorporateCustomerSpecialAccounts(function () {

                        });
                    } else {
                        block_edit_corporate_user.stop();
                    }
                });
        };

        $scope.AddSpecialAccountCorporateCustomer = function (corporateCustomerId, specialAccount) {

            $scope.AddOrEditSpecialAccountCorporateCustomer(corporateCustomerId, null, specialAccount);
        };

        $scope.EditSpecialAccountCorporateCustomer = function (corporateCustomerId, corporateCustomerSpecialAccountId) {
            $scope.AddOrEditSpecialAccountCorporateCustomer(corporateCustomerId, corporateCustomerSpecialAccountId);
        };

        function _makeDictTag(codesList, goodsList) {
            var result = [];

            if (codesList) {
                if (goodsList) {
                    codesList.forEach(function (code, index) {
                        goodsList.forEach(function (goodItem) {
                            if (code === goodItem.code) {
                                result.push(goodItem);
                            }
                        });
                    });
                } else if ($scope.state.goodsList) {
                    codesList.forEach(function (code, index) {
                        $scope.state.goodsList.forEach(function (goodItem) {
                            if (code === goodItem.code) {
                                result.push(goodItem);
                            }
                        });
                    });
                } else {
                    result = codesList;
                }
            }

            return result;
        }

        $scope.modalTaxesExempt = function (corporateCustomer, corporateCustomerSpecialAccount) {

            TaxesExemptInCorporateService.TaxesExempt(
                {
                    corporateCustomer: corporateCustomer,
                    corporateCustomerSpecialAccount: corporateCustomerSpecialAccount
                }
            );
        };

        $scope.AddOrEditSpecialAccountCorporateCustomer = function (corporateCustomerId, corporateCustomerSpecialAccountId, specialAccount) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/pages/corporates/corporate-users/modal/corporate-special-accounts.modal.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.currentTab = 'settings';
                    popup.onChangeTab = function (tabName) {
                        if (tabName === 'settings') {
                            popup.newPriceOption = undefined;
                        }

                        if (popup.isFormDirty) {
                            confirmationPopup('corp_account', popup.saveCorporateCustomerSpecialAccount, popup.onChangeTab, tabName);
                        } else {
                            popup.currentTab = tabName;
                        }

                    };
                    popup.ValueDependsCalcPeriod = {
                        'all': 'For all time',
                        'day': 'For day',
                        'week': 'For week',
                        'month': 'For months',
                        'three-month': 'For three months',
                        'year': 'For year',
                        'current-week': 'For this week (since Monday)',
                        'past-week': 'For last week (since Monday)',
                        'current-month': 'For current month (from the 1st)',
                        'past-month': 'For last month (from the 1st of the last month)',
                        'current-quarter': 'For current quarter',
                        'past-quarter': 'For last quarter',
                        'current-year': 'For current year (since January 1st)',
                        'past-year': 'For last year (since January 1st of the last year)'
                    };
                    popup.loading = true;
                    popup.isFormDirty = corporateCustomerSpecialAccountId ? false : true;
                    popup.specialAccountGoods = []; // Все товары
                    popup.availableSpecialAccountGoods = [];
                    popup._checkedGoodsItems = []; // Все товары
                    popup.goodsList = []; // Все товары
                    popup.goods_codes = []; // для отображения красивого списка
                    popup.isCreditLimitUnlimited = false;
                    popup.isDayLimitUnlimited = false;
                    popup.isMonthLimitUnlimited = false;
                    popup.isMoneyAccount = true;
                    popup.priceOptions = [];
                    popup.onDependsTypeSelect = function () {
                        if (popup.newPriceOption.value_depends_type === 'none') {
                            delete popup.newPriceOption.value_depends_matrix;
                            delete popup.newPriceOption.value_depends_calc_period;
                            delete popup.newPriceOption.value_depends_by_goods;
                            popup.validation.isValueValid = !!popup.newPriceOption.value;
                        } else {
                            if (!popup.newPriceOption.value_depends_matrix) {
                                popup.newPriceOption.value_depends_matrix = [
                                    {threshold: 0, value: null}
                                ];
                            }

                            if (!popup.newPriceOption.value_depends_calc_period) {
                                popup.newPriceOption.value_depends_calc_period = 'all';
                            }

                            if (!popup.newPriceOption.value_depends_by_goods) {
                                popup.newPriceOption.value_depends_by_goods = 'all';
                            }

                            popup.validation.isValueValid = true;
                        }
                    };
                    popup.isRuleValueCurrent = function (item) {
                        return item == popup.editingRule;
                    };
                    popup.ruleValueEditClick = function (value) {
                        popup.isRuleValueEdit = true;
                        popup.editingRule = value;
                        popup.backupRule = angular.copy(value);
                    };
                    popup.ruleValueDeleteClick = function (value) {
                        if (popup.newPriceOption.value_depends_matrix.length === 1) {
                            popup.newPriceOption.value_depends_matrix = [
                                {threshold: 0, value: null}
                            ];

                            popup.ruleValueEditClick(popup.newPriceOption.value_depends_matrix[0]);
                            return;
                        }
                        popup.newPriceOption.value_depends_matrix.forEach(function (item) {
                            if (item == value) {
                                popup.newPriceOption.value_depends_matrix.splice(popup.newPriceOption.value_depends_matrix.indexOf(value), 1);
                            }
                        });
                    };
                    popup.onCancelRuleValue = function () {
                        popup.isRuleValueEdit = false;

                        if (popup.isRuleValueAdd) {
                            popup.ruleValueDeleteClick(popup.editingRule);
                        } else {
                            popup.editingRule.card_category_id = popup.backupRule.card_category_id;
                            popup.editingRule.threshold = popup.backupRule.threshold;
                            popup.backupRule = null;
                            popup.editingRule = null;
                        }

                        popup.isRuleValueAdd = false;
                    };
                    popup.onAddRuleThreshold = function (fromFields) {
                        var value_is_null_index = popup.newPriceOption.value_depends_matrix.findIndex(function (v) {
                            return v.value === null;
                        });

                        if (value_is_null_index !== -1) {

                            if (fromFields['rule_value_' + value_is_null_index])
                                fromFields['rule_value_' + value_is_null_index].$dirty = true;
                            if (fromFields['rule_threshold_' + value_is_null_index])
                                fromFields['rule_threshold_' + value_is_null_index].$dirty = true;
                            return;
                        }

                        popup.newrule = {
                            threshold: 0,
                            value: null
                        };
                        popup.isRuleValueAdd = true;
                        popup.isRuleValueEdit = true;
                        popup.newPriceOption.value_depends_matrix.push(popup.newrule);

                        popup.editingRule = popup.newrule;

                    };
                    popup.onSaveRuleValue = function (item, index, form) {
                        var rule_values_error = false;
                        for (var i in form.$error.required) {
                            if (!rule_values_error && /(rule_value_|rule_threshold_)/.test(form.$error.required[i].$name)) {
                                rule_values_error = true;
                            }
                        }
                        if (item && !rule_values_error) {
                            var existThreshold = false;
                            var existValue = false;

                            popup.newPriceOption.value_depends_matrix.forEach(function (item) {
                                if (!(item == popup.editingRule) && (item.threshold == popup.editingRule.threshold)) existThreshold = true;
                                //if (!(item == popup.editingRule) && (item.value == popup.editingRule.value)) existValue = true;
                            });

                            if (existThreshold) {
                                NotifyService.Warning('Threshold with same value exists!', false);
                                // } else if (existValue) {
                                //   NotifyService.Warning('Price with same value exists!', false);
                            } else {
                                // OK, store
                                popup.isRuleValueEdit = false;
                                popup.isRuleValueAdd = false;
                                popup.editingRule = null;
                                popup.backupRule = null;

                                var orderBy = $filter('orderBy');
                                popup.newPriceOption.value_depends_matrix = orderBy(popup.newPriceOption.value_depends_matrix, 'threshold', false);
                            }

                        } else {
                            if (form['rule_value_' + index])
                                form['rule_value_' + index].$dirty = true;
                            if (form['rule_threshold_' + index])
                                form['rule_threshold_' + index].$dirty = true;
                        }
                    };
                    popup.priceOptionsValueDependsTypes = [
                        {id: 'none', title: 'price_option_value_depends_type#none'},
                        {id: 'amount', title: 'price_option_value_depends_type#amount'},
                        {id: 'quantity', title: 'price_option_value_depends_type#quantity'}
                    ];
                    popup.priceOptionsValueDependsCalcPeriod = [
                        {id: 'all', title: 'For all time'},
                        {id: 'day', title: 'For day'},
                        {id: 'week', title: 'For week'},
                        {id: 'month', title: 'For months'},
                        {id: 'three-month', title: 'For three months'},
                        {id: 'year', title: 'For year'},
                        {id: 'current-week', title: 'For this week (since Monday)'},
                        {id: 'past-week', title: 'For last week (since Monday)'},
                        {id: 'current-month', title: 'For current month (from the 1st)'},
                        {id: 'past-month', title: 'For last month (from the 1st of the last month)'},
                        {id: 'current-quarter', title: 'For current quarter'},
                        {id: 'past-quarter', title: 'For last quarter'},
                        {id: 'current-year', title: 'For current year (since January 1st)'},
                        {id: 'past-year', title: 'For last year (since January 1st of the last year)'}
                    ];

                    popup.priceOptionsValueDependsByGoods = [
                        {id: 'all', title: 'price_option_value_depends_by_goods#all'},
                        {id: 'current', title: 'price_option_value_depends_by_goods#current'}
                    ];
                    popup.priceOptionsTypes = [
                        {id: 'markup', title: 'price_option_type#markup'},
                        {id: 'discount', title: 'price_option_type#discount'}
                    ];
                    popup.priceOptionsBaseValueTypes = [
                        {id: 'posted-price', title: 'price_option_base_value_type#posted-price'},
                        {id: 'price-including-taxes', title: 'price_option_base_value_type#price-including-taxes'}
                    ];
                    popup.priceOptionsValueTypes = [
                        {id: 'amount', title: 'price_option_value_type#amount'},
                        {id: 'percentage', title: 'price_option_value_type#percentage'}
                    ];
                    popup.validation = {
                        isItemValid: true,
                        isValueValid: true
                    };
                    popup.customerInfo = '';
                    if (specialAccount) {
                        BusinessService.getSpecialAccountGoods(specialAccount.id, function (success, data) {
                            if (success) {
                                popup.specialAccountGoods = data;
                            }
                        });
                    }

                    if (!!corporateCustomerSpecialAccountId) {
                        refreshPriceOptions();
                    }

                    function refreshPriceOptions(callback) {
                        CorporateCustomerService.GetPriceOptions(corporateCustomerId, corporateCustomerSpecialAccountId, function (success, data) {
                            popup.priceOptions = data;
                            if (callback) {
                                callback();
                            }
                            popup.loading = false;
                        });
                    }

                    // popup.newPriceOption = {
                    //     type: 'markup',
                    //     base_value_type: 'posted-price',
                    //     value_type: 'amount',
                    //     value: null
                    // }

                    function confirmationPopup(type, save, changeTab, tab) {
                        return $scope.modal.confirmation = $uibModal.open({
                            animation: true,
                            keyboard: true,
                            size: 'sm',
                            templateUrl: 'app/templates/modal.confirmation.html',
                            controllerAs: 'popup',
                            controller: function ($uibModalInstance) {
                                var popup = this;

                                popup.type = type;

                                popup.onSaveClick = function (exit) {
                                    save(function () {
                                        changeTab(tab);
                                    });
                                    $uibModalInstance.close();
                                };

                                popup.onCancelClick = function (exit) {
                                    $uibModalInstance.close();
                                };
                            }
                        });
                    }

                    popup.cancelPriceOption = function () {
                        popup.newPriceOption = undefined;
                        popup.validation.isItemValid = true;
                        popup.validation.isValueValid = true;
                    };
                    popup.deletePriceOption = function (row) {
                        popup.loading = true;
                        CorporateCustomerService.DeletePriceOptions(
                            corporateCustomerId,
                            row.corporate_customer_special_account_id,
                            row.item_id,
                            function (success, data) {
                                if (success) {
                                    refreshPriceOptions(function () {

                                    });
                                }
                            }
                        );
                    };
                    popup.editPriceOption = function (row) {
                        popup.newPriceOption = row;
                    };
                    popup.AddPriceOption = function () {
                        popup.loading = true;
                        CorporateCustomerService.GetAvailableGoodsCorporateCustomer(
                            corporateCustomerId,
                            corporateCustomerSpecialAccountId,
                            function (success, data) {
                                if (success) {
                                    popup.availableSpecialAccountGoods = data.filter(
                                        function (x) {
                                            return !popup.priceOptions.some(function (g) {
                                                return g.item_id === x.id;
                                            });
                                        });
                                    if (popup.availableSpecialAccountGoods.length) {
                                        popup.newPriceOption = {
                                            type: 'markup',
                                            base_value_type: 'posted-price',
                                            value_type: 'amount',
                                            value_depends_type: 'none',
                                            value: null
                                        };
                                    } else {
                                        confirmationPopup('alert_corp_account');
                                    }
                                }
                                popup.loading = false;
                            });
                    };
                    popup.savePriceOption = function () {
                        var priceOption = angular.copy(popup.newPriceOption);
                        console.log('savePriceOption', priceOption);
                        popup.validation.isValueValid = !!priceOption.value;
                        popup.validation.isItemValid = !!priceOption.item_id;
                        // if (!priceOption.item_id) {
                        //   return;
                        // }
                        popup.loading = true;

                        if (priceOption.item_title) {
                            CorporateCustomerService.UpdatePriceOptionsItem(
                                corporateCustomerId,
                                corporateCustomerSpecialAccountId,
                                priceOption.item_id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        refreshPriceOptions(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        popup.loading = false;
                                    }

                                });
                        } else {
                            CorporateCustomerService.AddPriceOptions(
                                corporateCustomerId,
                                corporateCustomerSpecialAccountId,
                                priceOption,
                                function (success, data) {
                                    // popup.priceOptions = data;
                                    if (success) {
                                        NotifyService.Success('', false);
                                        refreshPriceOptions(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        popup.loading = false;
                                    }

                                });
                        }

                    };

                    popup.changeValue = function () {
                        popup.validation.isValueValid = true;
                    };

                    popup.changeItem = function () {
                        popup.validation.isItemValid = true;
                    };

                    // корпаротивные счета
                    //  popup.corporate_special_accounts = angular.copy($scope.model.corporate_special_accounts);

                    // текущий корпоративный клиент
                    popup.corporate_customer = angular.copy($scope.model.corporate_customer);
                    popup.corruptedFields = [];

                    popup.changeGoodsItem = function (goodCode, event) {
                        popup.isFormDirty = true;
                        if (event) {
                            event.stopPropagation();
                        }
                        if (!popup.corporate_customer_special_account.goods_items.includes(goodCode)) {
                            popup.corporate_customer_special_account.goods_items.push(goodCode);
                        } else {
                            popup.corporate_customer_special_account.goods_items = (popup.corporate_customer_special_account.goods_items || []).filter(
                                function (item) {
                                    return item !== goodCode;
                                });
                        }

                        popup.goods_codes = _makeDictTag(popup.corporate_customer_special_account.goods_items);
                    };

                    if (!!corporateCustomerSpecialAccountId) {
                        // получаем актуальные данные
                        CorporateCustomerService.GetCorporateCustomerSpecialAccount(corporateCustomerId, corporateCustomerSpecialAccountId,
                            function (success, data) {
                                if (!success) {
                                    popup.closeModal();
                                } else {
                                    createObjectModel(data);
                                }
                            });
                    } else {
                        createObjectModel({
                            corporate_customer_id: popup.corporate_customer.id,
                            credit_limit: specialAccount.credit_limit,
                            credit_type: specialAccount.credit_type,
                            day_limit: 0,
                            goods_items: specialAccount.goods_items ? specialAccount.goods_items : [],
                            month_limit: 0,
                            special_account_id: specialAccount.id,
                            special_account_title: '',
                            available_from: null,
                            available_until: null,
                            active: 1
                        });
                    }

                    function createObjectModel(corporate_customer_special_account) {
                        popup.availablePosList = [];
                        popup.isCreditLimitUnlimited = !(corporate_customer_special_account.credit_limit);
                        popup.isDayLimitUnlimited = !(corporate_customer_special_account.day_limit);
                        popup.isMonthLimitUnlimited = !(corporate_customer_special_account.month_limit);
                        popup.isMoneyAccount = corporate_customer_special_account.special_account_type === 'money';
                        popup.customerInfo = corporate_customer_special_account.info ? decodeURIComponent(corporate_customer_special_account.info) : '';

                        if (corporate_customer_special_account.available_until || corporate_customer_special_account.available_from) {
                            corporate_customer_special_account.available_date = 1;

                            if (corporate_customer_special_account.available_until) {
                                corporate_customer_special_account.available_until = moment(corporate_customer_special_account.available_until).utcOffset(0, true).format();
                            }

                            if (corporate_customer_special_account.available_from) {
                                corporate_customer_special_account.available_from = moment(corporate_customer_special_account.available_from).utcOffset(0, true).format();
                            }
                        }

                        POSService.All({}, function (success, data) {
                            if (success) {
                                var posList = angular.copy(data);
                                popup.availablePosList = posList.filter(function (pos) {
                                    return pos.active;
                                });
                                if (popup.corporate_customer_special_account && popup.corporate_customer_special_account.pos) {
                                    for (var elem in popup.corporate_customer_special_account.pos) {
                                        popup.corporate_customer_special_account.pos[elem] = itemByIndex(popup.availablePosList,
                                            popup.corporate_customer_special_account.pos[elem].id);
                                    }
                                }

                            }
                        });
                        BusinessService.getSpecialAccountGoods(corporate_customer_special_account.special_account_id, function (success, data) {
                            if (success) {
                                $scope.state.goodsList = angular.copy(data);
                                popup.goodsList = angular.copy(data);
                                popup.specialAccountGoods = angular.copy(data);
                                popup.goods_codes = _makeDictTag(corporate_customer_special_account.goods_items, data);
                                popup.corporate_customer_special_account = corporate_customer_special_account;
                                popup.loading = false;
                            }
                        });
                    }

                    popup.saveCorporateCustomerSpecialAccount = function (callback) {
                        popup.loading = true;
                        var corporate_customer_special_account = angular.copy(popup.corporate_customer_special_account);
                        block_edit_corporate_user.start();

                        if (corporate_customer_special_account.available_date) {
                            if (corporate_customer_special_account.available_from) {
                                corporate_customer_special_account.available_from = moment(corporate_customer_special_account.available_from).utc().toISOString();
                            }

                            if (corporate_customer_special_account.available_until) {
                                corporate_customer_special_account.available_until = moment(corporate_customer_special_account.available_until).utc().toISOString();
                            }
                        } else {
                            corporate_customer_special_account.available_from = null;
                            corporate_customer_special_account.available_until = null;
                        }

                        delete corporate_customer_special_account.available_date;

                        function _makeTagArray(d) {
                            var result = [];
                            if (d)
                                d.forEach(function (item) {
                                    result.push(item.code);
                                });
                            return result;
                        }

                        corporate_customer_special_account.goods_items = _makeTagArray(popup.goods_codes || form.goods.$modelValue) || [];

                        if (corporate_customer_special_account.goods_items) {
                            corporate_customer_special_account.goods_items = corporate_customer_special_account.goods_items.filter(
                                function (value, index, self) {
                                    return self.indexOf(value) === index;
                                });
                        }

                        corporate_customer_special_account.info = popup.customerInfo
                            ? encodeURIComponent($sce.getTrustedHtml(popup.customerInfo))
                            : '';
                        // popup.corporate_customer_special_account.info = popup.customerInfo

                        if (!!corporate_customer_special_account.id) {
                            CorporateCustomerService.UpdateCorporateCustomerSpecialAccount(
                                popup.corporate_customer.id,
                                corporate_customer_special_account.id,
                                corporate_customer_special_account,
                                function (success, data) {
                                    if (success) {
                                        popup.loading = false;
                                        popup.isFormDirty = false;
                                        if (callback) {
                                            callback();
                                        }
                                        refreshCorporateCustomerSpecialAccounts(function () {

                                        });
                                    } else {
                                        popup.loading = false;

                                        block_edit_corporate_user.stop();
                                    }
                                });
                        } else {
                            CorporateCustomerService.AddCorporateCustomerSpecialAccount(popup.corporate_customer.id,
                                corporate_customer_special_account, function (success, data) {
                                    if (success) {
                                        corporate_customer_special_account = data;
                                        popup.loading = false;
                                        popup.isFormDirty = false;
                                        if (callback) {
                                            callback();
                                        }
                                        refreshCorporateCustomerSpecialAccounts(function () {

                                        });
                                    } else {
                                        popup.loading = false;
                                        block_edit_corporate_user.stop();
                                    }
                                });
                        }
                    };
                    popup.saveAndClose = function () {
                        popup.saveCorporateCustomerSpecialAccount(
                            function () {
                                popup.closeModal();
                            }
                        );
                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                        popup.isFormDirty = false;
                    };

                }
            });
        };

        function refreshCorporateCustomerSpecialAccounts(callback) {
            if (!$routeParams.customer_id) {
                if (callback) {
                    callback();
                }

                block_edit_corporate_user.stop();
                return;
            }

            // Получаем счета с признаком корпоративный
            BusinessService.SpecialAccountsParams({scope: 'corporate'}, function (success, data) {
                if (success) {
                    var corporate_special_accounts = data;

                    // Получаем корпаративные счета корпаративного клиента
                    CorporateCustomerService.GetCorporateCustomerSpecialAccounts($routeParams.customer_id, function (success, data) {
                        if (success) {
                            corporate_special_accounts.map(function (corporate_special_account) {
                                corporate_special_account.corporate_customer_special_account = data.find(function (item) {
                                    return corporate_special_account.id === item.special_account_id;
                                });
                            });
                            $scope.model.corporate_customer_special_accounts = data;

                        }

                        $scope.model.corporate_special_accounts = corporate_special_accounts;
                        if (callback) {
                            callback();
                        }
                        block_edit_corporate_user.stop();
                    });
                } else {
                    if (callback) {
                        callback();
                    }
                    block_edit_corporate_user.stop();
                }

            });
        }

        $scope.stripFormat = function ($html) {
            var ff = $filter('htmlToPlaintext')($html);
            return ff;
        };

        $scope.AddOrEditField = function (fieldId) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/corporates/corporate-users/modal/add-field.modal.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    popup.platformSupportedLanguagesCodes = angular.copy($scope.platformSupportedLanguagesCodes);
                    popup.fieldLang = $scope.multilang.lang;
                    popup.corruptedFields = [];

                    popup.pasteTagHandler = function (values) {
                        var separators = [',', '\n'],
                            separator,
                            values_list;

                        for (var i in separators)
                            if (values && values.indexOf(separators[i]) > 0)
                                separator = separators[i];

                        if (separator)
                            values_list = values.replace(' ', '').split(separator);

                        if (values_list && values_list.length > 0) {
                            values_list = values_list.filter(function (elem, index, self) {
                                return index == self.indexOf(elem);
                            });

                            for (var i in values_list) {
                                if (values_list[i]) {
                                    this.ngModel.$modelValue.push(values_list[i]);
                                }
                            }
                        }
                    };

                    popup.field = {
                        title: '',
                        type: 'string',
                        dictionary_values: [],
                        public_description: {},
                        public_title: {}
                    };
                    if (!!fieldId) {
                        CorporateCustomerService.CorporateFieldGet(fieldId, function (success, data) {
                            if (!success) {
                                refreshFields(function () {
                                    popup.closeModal();
                                });
                            } else {
                                popup.field = data;
                            }
                        });
                    }

                    popup.changeTitleLang = function (lang) {
                        if (lang === undefined) {
                            lang = $scope.multilang.lang;
                        }

                        popup.fieldLang = lang;
                    };
                    popup.fieldValidator = {
                        isTitleValid: function (formData) {
                            var form = formData || popup.field;
                            return !!form && form.title.length;
                        },
                        isPublicTitleValid: function (formData) {
                            var form = formData || popup.field;

                            if (!formData.public_title) {
                                return false;
                            }
                            var titleNotEmpty = Object.values(form.public_title).find(function (title) {
                                return (title && title.length) > 0 ? true : false;
                            });
                            return titleNotEmpty ? true : false;
                        }
                    };

                    function validateField() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };

                        for (var validatorName in popup.fieldValidator) {
                            var isValid = popup.fieldValidator[validatorName](popup.field);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }

                        return validationResult;
                    }

                    popup.saveField = function () {
                        var validationResult = validateField();

                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }

                        block_fields_list.start();
                        if (!!popup.field.id) {
                            CorporateCustomerService.CorporateFieldChange(popup.field.id, popup.field, function (success, data) {
                                if (success) {
                                    refreshFields(function () {
                                        popup.closeModal();
                                    });
                                } else {
                                    block_fields_list.stop();
                                }
                            });
                        } else {
                            CorporateCustomerService.CorporateFieldAdd(popup.field, function (success, data) {
                                if (success) {
                                    refreshFields(function () {
                                        popup.closeModal();
                                    });
                                } else {
                                    block_fields_list.stop();
                                }
                            });
                        }

                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };

                }
            });
        };

        /**
         * Save existing field
         */
        $scope.onFieldSave = function (field) {
            CorporateCustomerService.CorporateFieldChange(field.id, field, function (success, data) {
                if (success) {
                    refreshFields(function () {
                        doEditFields();
                    });
                } else {
                    block_fields_list.stop();
                }
            });
        };

        /**
         * Delete existing field
         */
        $scope.onDeleteFieldClick = function (f) {
            block_fields_list.start();
            CorporateCustomerService.CorporateFieldDelete(f.id, function (success, data) {
                if (success) {
                    refreshFields(function () {

                    });
                } else {
                    block_fields_list.stop();
                }
            });
        };

        /**
         * Saving custome fields order
         */
        $scope.onSaveFieldOrderClick = function () {
            block_fields_list.start();
            var post_data = [];
            for (var i in $scope.customerFields) {
                post_data.push($scope.customerFields[i].id);
                $scope.customerFields[i].sort_order = parseInt(i);
            }

            CorporateCustomerService.CorporateFieldsSaveOrders(post_data, function (success, data) {
                if (success) {
                    refreshFields(function () {
                        NotifyService.Success('', false);
                    });
                } else {
                    block_fields_list.stop();
                }
            });
        };

        $scope.pasteTagHandler = function (values) {
            var separators = [',', '\n'],
                separator,
                values_list;

            for (var i in separators)
                if (values && values.indexOf(separators[i]) > 0)
                    separator = separators[i];

            if (separator)
                values_list = values.replace(' ', '').split(separator);

            if (values_list && values_list.length > 0) {
                values_list = values_list.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                });

                for (var i in values_list) {
                    if (values_list[i]) {
                        this.ngModel.$modelValue.push(values_list[i]);
                    }
                }
            }
        };

        /**
         * Return style for column header
         * @param col_name: Column (field) name
         * @returns {{sorting_asc: boolean, sorting_desc: boolean}}
         */
        $scope.getTableHeaderClass = function (row) {
            if (!row.sorting) {
                return {};
            }

            return {
                'sorting': true,
                'sorting_asc': $scope.params.sort == row.sorting && $scope.params.order == 'asc',
                'sorting_desc': $scope.params.sort == row.sorting && $scope.params.order == 'desc'
            };
        };

        /**
         * handling sort order
         */
        $scope.onSortOrderChange = function (row) {
            if (!row.sorting) {
                return;
            }
            $scope.state.selectedAll = false;
            $scope.selectedUsers = {};

            if ($scope.params.sort === row.sorting)
                $scope.params.order = $scope.params.order === 'asc' ? 'desc' : 'asc';
            else
                $scope.params.order = 'asc';

            $scope.params.sort = row.sorting;
            getCustomers();
        };

        /**
         * Received when user chane page
         */
        $scope.pageChange = function () {
            getCustomers();
        };

        /**
         * handling items on page count
         */
        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getCustomers();
        };

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
                if (newValue && newValue.length > 0) {

                    if (!$scope.data.currentFilter)
                        $scope.data.currentFilter = getFirstActive($scope.data.filtersList);

                    var cf = $scope.data.currentFilter;

                }
            }
        );

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {

            console.log('watch data.currentFilter', newValue);
            if (newValue && newValue !== oldValue && $scope._pageMode === 'show') {
                // $scope.filterHelper.id = newValue.filter_list_type == 'pos' ? newValue.loyalty_id : newValue.id;

                doShow();

                $scope.selectedUsers = {};
                // $scope.customersFilters.removeCardCategoryCondition();

                $rootScope.ENV.filters.customers_list = {
                    filter: newValue
                };

            }
        }, true);

        $scope.onCustomersExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_clients_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });
            var CURR_TIME = new Date();
            if (getCustomersInProcessFrom && (CURR_TIME - getCustomersInProcessFrom) < 180) {
                console.warn('Previous getCustomers() in process. Skip.');
                return;
            } else {
                getCustomersInProcessFrom = CURR_TIME;
            }

            block_clients_list.start();

            var cf = $scope.data.currentFilter,
                params = {
                    page: $scope.params.page,
                    count: $scope.params.count,
                    email: $scope.params.email,
                    search_text: $scope.params.search_text,
                    suspended: $scope.params.suspended
                };
            if ($scope.params.sort) {
                params.sort = $scope.params.sort;
            }
            if ($scope.params.order) {
                params.order = $scope.params.order;
            }
            params.slow_request = true;

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_corporate_users';

                var export_struct = ExportService.getTableForExcel(format, angular.copy($scope.table_cols));

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;

                        switch (export_struct[k].value) {
                            case 'corporate_login':
                                b = tl[i]['email'];
                                break;
                            case 'corporate_name':
                                b = tl[i]['name'];
                                break;
                            case 'corporate_suspended':
                                b = tl[i]['suspended'] === 1 ? $filter('translate')('Yes') : $filter('translate')('No');
                                break;
                            case 'corporate_contact_person':
                                b = [];
                                if (tl[i]['contacts']) {
                                    for (var y in tl[i]['contacts']) {
                                        b.push((tl[i]['contacts'][y]['contact_person'] || ' - '));
                                    }
                                }
                                b = b.join('\n');
                                break;
                            case 'corporate_contact_phones':
                                b = [];
                                if (tl[i]['contacts']) {
                                    for (var y in tl[i]['contacts']) {
                                        b.push((tl[i]['contacts'][y]['phones'] || ' - '));
                                    }
                                }
                                b = b.join('\n');
                                break;
                            case 'corporate_contact_mobile':
                                b = [];
                                if (tl[i]['contacts']) {
                                    for (var y in tl[i]['contacts']) {
                                        b.push((tl[i]['contacts'][y]['mobile'] || ' - '));
                                    }
                                }
                                b = b.join('\n');
                                break;
                            case 'corporate_contact_address':
                                b = [];
                                if (tl[i]['contacts']) {
                                    for (var y in tl[i]['contacts']) {
                                        b.push((tl[i]['contacts'][y]['address'] || ' - '));
                                    }
                                }
                                b = b.join('\n');
                                break;
                            case 'corporate_contact_email':
                                b = [];
                                if (tl[i]['contacts']) {
                                    for (var y in tl[i]['contacts']) {
                                        b.push((tl[i]['contacts'][y]['email'] || ' - '));
                                    }
                                }
                                b = b.join('\n');
                                break;

                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : $filter('translate')(tl[i][export_struct[k].value]);
                        }
                        el[a] = b;
                    }
                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                    block_clients_list.stop();
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }
            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.summary.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getCorporateCustomers(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.summary.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;
                tl.forEach(function (item) {
                    item.id = item.user_id;
                });
                generateFile();
            }

            function getCorporateCustomers(params) {
                return new Promise(function (resolve) {
                    CorporateCustomerService.All(params, function (success, response) {
                        resolve(response);
                    });
                });
            }

            exportRequest();
        };

        /**
         * Check if modification user data is denied
         */
        function isModifyDenied() {
            if (isPageMode('edit')) {
                return true;
            } else {
                return false;
            }
        }

        function getGoods(callback) {
            $scope.state.goodsList = [];
            GoodsService.GoodsInBusiness(function (success, data) {
                if (success) {
                    $scope.state.goodsList = angular.copy(data);
                }
                callback(success, data);
            });
        }

        $rootScope.$on('user-logout', function () {
            $scope.CORPORATE_CUSTOMER_FIELDS = {};
        });

        $rootScope.$watchCollection('[COUNTRIES[LANG]]', function (newCollection) {
            if (newCollection[0]) {
                $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[$rootScope.LANG]);
            }
        }, true);

    }

})();
